import { map } from 'rxjs';
import { randomUUID } from '@golden/utils';
export function addRequestId() {
    return map((config) => {
        config.headers['X-Request-Id'] = randomUUID();
        return config;
    });
}
//# sourceMappingURL=RequestId.js.map